import React from "react";
import styled, { css } from "styled-components";
import FacebookIcon from "./Icons/Facebook";
import LinkedInIcon from "./Icons/Linkedin";
import TwitterIcon from "./Icons/Twitter";

const SocialSharerStyles = styled.div`
  ${({ ...props }) => css`
    margin-bottom: 16px;
    display: flex;

    a {
      margin-left: 8px;
      text-decoration: underline;
      color: ${props.theme.colors.primary};
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
    }
  `}
`;

export const SocialSharer = ({ pageUrl, pageTitle }) => {
  const url = encodeURI(pageUrl);
  return (
    <SocialSharerStyles>
      Share
      <div>
        <a
          href={`http://www.twitter.com/share?url=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <span className="sr-only">Share on Twitter</span>
          <TwitterIcon />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <span className="sr-only">Share on Facebook</span>
          <FacebookIcon />
        </a>
        <a
          href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
          rel="noreferrer"
        >
          <span className="sr-only">Share on LinkedIn</span>
          <LinkedInIcon />
        </a>
      </div>
    </SocialSharerStyles>
  );
};
